define("settings/routes/users", ["exports", "@ember/object", "@ember/routing/route", "@ember/service", "@glimmer/tracking", "later/utils/promise-hash"], function (_exports, _object, _route, _service, _tracking, _promiseHash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/routing/route",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/promise-hash"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let UsersRoute = _exports.default = (_class = class UsersRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _initializerDefineProperty(this, "users", _descriptor7, this);
      _defineProperty(this, "usersSorting", ['createdTime']);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get sortedUsers() {
      return this.users.sortBy('usersSorting');
    }
    model() {
      return (0, _promiseHash.default)({
        users: this.store.query('user', {
          filter: {
            account_id: this.currentAccount.id
          }
        }),
        subscription: this.subscriptions.subscription
      });
    }
    afterModel(_ref) {
      let {
        users
      } = _ref;
      this.users = users;
      this._checkOverages();
    }
    setupController(controller) {
      controller.setProperties({
        users: this.sortedUsers,
        currentAccount: this.currentAccount,
        currentUser: this.currentUser,
        isPageRestricted: !this.settings.isAccountOwner,
        accountOwnerEmail: this.settings.accountOwnerEmail,
        shouldMigrate: !this.availableSeats && this.currentAccount.isOnLegacyPlan && !this.currentAccount.pricingV1Free,
        showContactModal: false
      });
    }
    handleUpdate() {
      this.auth.refresh();
      this.refresh();
    }
    _checkOverages() {
      if (this.currentAccount.shouldWarnOfPlanOverages && this.currentAccount.hasUsersOverage) {
        this.alerts.warning(this.intl.t('alerts.account.users.overages', {
          count: this.currentAccount.usersOverage
        }), {
          title: this.intl.t('alerts.account.overage')
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "users", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype)), _class);
});